import script from "./TemplateConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateConfig.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateConfig.vue?vue&type=style&index=0&id=41b84130&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b84130"]])

export default __exports__